export const queryKeys = {
    metadata: () => ["metadata"],
    token: () => ["token"],
    regions: () => ["regions"],
    products: () => ["products"],
    incidents: (query) => ["incidents", query],
    maintenances: (query) => ["maintenances", query],
    advisories: (query) => ["advisories", query],
    health: () => ["health"],
    notificationHealth: () => ["notificationHealth"],
    subscriptions: (query) => ["subscriptions", query],
    getRegions: "getRegions",
    getProducts: "getProducts",
    getIncidents: "getIncidents",
};

export default queryKeys;
